import { FC } from 'react';

import { HyperstarSparkleFilledSize16 } from '@hh.ru/magritte-ui/icon';

export const AiIcon: FC = () => (
    <HyperstarSparkleFilledSize16 initialColor="negative" backgroundStyle="primary" padding={8} borderRadius={8} />
);
